import * as React from 'react';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';

const TABLE_HEAD = (
    <tr>
        <th scope="col">Id Venta</th>
        <th scope="col">Id Cotización</th>
        <th scope="col">Peso Hasta</th>
        <th scope="col">Peso Aforado</th>
        <th scope="col">Código Postal</th>
        <th scope="col">Importe</th>
    </tr>
);

export default class LogisticaDeLiquidacion extends React.Component {
    render = () => {
        const logistica = this.props.logistica ?? [];

        return (
            <LiquidacionDetalleTabla
                title="Fee Logístico"
                data={logistica}
                isLoading={this.props.isLoading}
                loadingMessage="Cargando fee logistico de la liquidacion..."
                emptyMessage="No hay información de logistica para esta liquidación"
                tableHead={TABLE_HEAD}
                renderRow={(item, i, globalIndex) => (
                    <tr key={`${item.idVenta}-${item.idCotizacion}-${globalIndex}`} className="hover-background-color">
                        <td><small>{item.idVenta}</small></td>
                        <td><small>{item.idCotizacion}</small></td>
                        <td><small>{item.pesoHasta}</small></td>
                        <td><small>{item.pesoAforado ?? '-'}</small></td>
                        <td><small>{item.codigoPostal}</small></td>
                        <td><small>${item.importe}</small></td>
                    </tr>
                )}
            />
        );
    };
}
